import { DISEASES_COLORS } from "../components/Const/colors";

const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

export const HighChartsConvertLineData = (result, except_diseases, time_view) => {
    var labels = [];
    var maxcolors = [];
    var datasets = [];
    
    result.forEach((obj, i) => {
        labels[i] = (time_view === undefined ?
            obj.key :
            (time_view === 'Y' ?
                '' :
                time_view === 'M' ?
                    month[parseInt(obj.key.slice(4)) - 1] :
                    time_view + parseInt(obj.key.slice(4)) + '/'
            )
            +
            (time_view === 'Y' ?
                obj.key.slice(0, 4) :
                obj.key.slice(2, 4)
            )
        )
        const diseases = obj.diseases;
        diseases.forEach(({ __typename, name, count }, j) => {
            datasets.forEach(({ label, data }, k) => {
                if (label === name) {
                    data.push(count);
                }
            })
            if (i === 0) {
                var dataset = {};
                dataset['label'] = name;
                dataset['data'] = [count];
                datasets[j] = dataset;
            }
        })

        const color = diseases.slice().sort(function (a, b) {
            return b.count - a.count; // Sort tooltip by most films
        }).filter(({ __typename, name, count }, j) =>
            // ไม่มี list โรคที่ไม่สนใจ หรือ (มี list โรคที่ไม่สนใจ และ ชื่อโรคนั้นไม่อยู่ใน list)
            ((except_diseases === undefined) || (except_diseases !== undefined && except_diseases.indexOf(name) === -1))
        ).map(({ __typename, name, count }, j) => {
            return DISEASES_COLORS.filter((item) => item.disease === name)[0].color // map color
        })[0] // เอาอันแรกสุด คือมีค่า max films
        maxcolors.push(color)
    });

    // มี list โรคที่ไม่สนใจ
    if (except_diseases !== undefined) {
        // เอาโรคที่ไม่อยู่ใน list ออก
        datasets = datasets.filter((dataset) => except_diseases.indexOf(dataset.label) === -1)
    }

    datasets.forEach((dataset,) => {
        dataset['borderColor'] = DISEASES_COLORS.filter((item) => item.disease === dataset.label)[0].color
    })

    return {
        labels: labels,
        datasets: datasets,
        maxcolors: maxcolors,
    };
}

export const HighChartsConvertMapPieData = (result, except_diseases) => {
    const labels = result[0].diseases.map(({ __typename, name, count }, i) => {
        return name
    })

    const datasets = result.map((data) => {
        var obj = {
            label: data.key,
            data: []
        }
        labels.forEach((label) => {
            // ไม่มี list โรคที่ไม่สนใจ หรือ (มี list โรคที่ไม่สนใจ และ ชื่อโรคนั้นไม่อยู่ใน list)
            if ((except_diseases === undefined) || (except_diseases !== undefined && except_diseases.indexOf(label) === -1)) {
                obj.data.push(
                    data.diseases.filter((disease) => disease.name === label)[0].count
                )
            } else {
                // ถ้าเป็นอันที่ยกเว้นให้ใส่ค่า 0 เข้าไปแทน เพราะ HighCharts ไม่อนุญาติให้เปลี่ยน keys ของ series mapchart
                obj.data.push(0)
            }
        })
        return obj
    })

    var pieColor = []
    var mapColor = []

    labels.forEach((label) => {
        pieColor.push(DISEASES_COLORS.filter((item) => item.disease === label)[0].color);
        mapColor.push(DISEASES_COLORS.filter((item) => item.disease === label)[0].color2);
    })

    return {
        labels: labels,
        datasets: datasets,
        pieColor: pieColor,
        mapColor: mapColor
    };
}

export const HighChartsConvertTreemapData = (result, except_diseases) => {
    // {id: 'id_0', name: 'Hos A', color: 'color of max diseases'}
    // {id: 'id_0_0', name: 'A diseases', parent: 'id_0', value: 103}

    // { id: 'id_1', name: 'Hos B', color: 'rgba(105,88,255,1)' },
    // { id: 'id_1_0', name: 'A diseases', parent: 'id_1', value: 103 },
    var data = []
    result.forEach((obj, i) => {
        data.push({
            id: 'id_' + i,
            name: obj.key,
            color: DISEASES_COLORS.filter((item) =>
                item.disease === obj.diseases
                    // เอาโรคที่ไม่อยู่ใน list ออก
                    .filter((dataset) => except_diseases.indexOf(dataset.name) === -1)
                    // หาโรคที่มี Films มากที่สุด
                    .reduce(function (prev, current) {
                        return (prev.count > current.count) ? prev : current
                    }).name
            )[0].color
        })
        obj.diseases.forEach(({ __typename, name, count }, j) => {
            // ไม่มี list โรคที่ไม่สนใจ หรือ (มี list โรคที่ไม่สนใจ และ ชื่อโรคนั้นไม่อยู่ใน list)
            if ((except_diseases === undefined) || (except_diseases !== undefined && except_diseases.indexOf(name) === -1))
                data.push({ id: 'id_' + i + '_' + j, name: name, parent: 'id_' + i, value: count })
        })
    });
    return data
}

export const HighChartsConvertPieDonutData = (result, except_diseases) => {
    return result.map((obj, i) => {
        return {
            hos: obj.key,
            diseases: obj.diseases.filter(({ __typename, name, count }, j) =>
                // ไม่มี list โรคที่ไม่สนใจ หรือ (มี list โรคที่ไม่สนใจ และ ชื่อโรคนั้นไม่อยู่ใน list)
                ((except_diseases === undefined) || (except_diseases !== undefined && except_diseases.indexOf(name) === -1))
            ).map(({ __typename, name, count }, j) => {
                return {
                    name: name,
                    y: count,
                    color: DISEASES_COLORS.filter((item) => item.disease === name)[0].color
                }
            })
        }
    });
}